import Button from "../components/Button"
import { ContentWork } from "../components/ContentWork"
import { Link } from "react-router-dom"
import TestImage from "../assets/panel_surya_rent.jpg"
import Video from "../assets/nusa.mp4"

export default function MitraEnergi(params) {
    return (
        <>
            <div className="lg:mx-16 p-2">
                <div className="lg:flex lg:max-w-full mb-5 w-full">
                    <div className="p-6 ml-8 w-full lg:w-1/2">
                        <div>
                            <h2 className="mb-2 text-4xl font-bold text-gray-900">Mitra Energi</h2>
                            <h2 className="mb-2 text-2xl font-normal text-gray-900">Semua bisa menjadi mitra Energi Masa Depan</h2>
                            <h4 className="mb-12 mt-12 text-sm font-normal text-gray-900">Kamu bisa menjadi mitra energi dengan memberikan referensi/rujukan pihak (pabrik, hotel, rumah sakit, dsbnya) yang tertarik dalam mengadopsi panel surya. Tentu saja, ada komisi menunggumu !</h4>
                        </div>
                        <div className="mb-5">
                            <li>
                                Isi formulir pendaftaran mitra energi
                            </li>
                            <li>
                                Kami akan mengontak kamu untuk proses selanjutnya.
                            </li>
                            <li>
                                Terima komisi saat kontrak sewa milik dengan referensimu
                            </li>
                        </div>
                        <Link to="/isi-formulir">
                            <Button
                                type="button"
                                buttonStyle="bg-black"
                                onClick={() => console.log("You clicked on the pink circle!")}
                                children="Isi Formulir"
                            />
                        </Link>
                    </div>
                    <img src={TestImage} alt=''
                        className="w-1/1 lg:w-1/3 lg:h-100 rounded-md" />
                </div>
            </div>
            <div className="bg-blue-400 h-1/2 w-full mt-20 p-1 lg:p-7">
                <div className="mx-8 my-20 p-4 lg:flex lg:max-w-full">
                    <div className="text-white text-3xl w-full lg:w-1/2 lg:text-5xl">
                        Mitra Energi
                    </div>
                    <div className="w-full mt-8 lg:w-1/2 lg:mt-0">
                        <video controls src={Video} type="video/mp4" />
                    </div>
                </div>
            </div>
            <div className="mt-6 mx-16">
                <p className="mb-6 font-bold text-3xl">Menjadi Mitra Energi itu sederhana</p>
                <ContentWork
                    title=" Isi formulir pendaftaran mitra energi"
                    subtitle="Langkah Pertama"
                    description="Pendaftaran menjadi Mitra Energi dilakukan secara online, data data yang kamu unggah akan kami jaga kerahasiaannya."
                />
                <ContentWork
                    title="Kami akan mengontak kamu untuk proses selanjutnya"
                    subtitle="Langkah Kedua"
                    description="Tim kami akan menghubungi kamu untuk diskusi lebih lanjut tentang detail dari referensimu."
                />
                <ContentWork
                    title="Terima komisi saat kontrak sewa milik dengan referensimu"
                    subtitle="Langkah Ketiga"
                    description="Kami menyediakan komisi yang menarik untukmu ketika referensimu setuju untuk menggunakan Energi Masa Depan."
                />
            </div>
        </>
    )
}